import Component from '@glimmer/component';

export default class MwContainer extends Component {
}
